/**
 * ## cortex:std:ArgumentError
 * Custom error type to throw when argument checking fails.
 */
export class ArgumentError extends Error {
	constructor(public message: string) {
		super(message);
		this.name = 'ArgumentError';
		Object.setPrototypeOf(this, ArgumentError.prototype);
	}
}
